<div class="modal" [ngClass]="{'show' :config?.showTrialSuccess}">

  <div class="modal-content">
    <div class="modal-content__body-container">
      <div class="modal-header">
        <h3 class="no-margin-buttom">{{'eos-tv-shop-ii.title.trial-success' | translate}} <img class="modal-logo" src="{{logoUrl}}"/></h3>
      </div>

      <p [translate]="'eos-tv-shop-ii.text.trial-success'" [translateParams]="{packageName : trialName()}"></p>

      <app-navigable-button
        [x]="0"
        [y]="0"
        [ownerComponent]="componentName"
        class="btn-grey"
        [widthPercentage]="95"
        (emitOnEnterPressed)="backPressed()"
        (emitOnBack)="backPressed()">
        <span [translate]="'eos-tv-shop-ii.btn.close'"></span>
      </app-navigable-button>
    </div>
  </div>
</div>
